export default __webpack_public_path__ + "static/media/avi.81f98792.svg";